<div class="content-area">
  <app-loading-component *ngIf="isLoading"></app-loading-component>
  <div class="clr-row" *ngIf="!isLoading">
    <div class="clr-col-10 clr-col-md-8">
      <h1>Jocuri biblice și activități</h1>
    </div>
    <div class="clr-col-10 clr-col-md-8" id="posts-wrapper">
      <app-activity-thumbnail *ngFor="let post of posts" [postData]="post"></app-activity-thumbnail>
      <div *ngIf="!posts || (posts && posts.length < 1)" class="text-center">
        Ne pare rău, se pare că nu avem încă conținut în această secțiune.
      </div>
    </div>
  </div>
  <app-pagination
          [page]="page"
          [pagesCount]="pagesCount"
          *ngIf="!isLoading"
          (pageChange)="onPageChange($event)"
  ></app-pagination>
</div>
